import React, { Component } from "react";
import Slider from "react-slick";
import leftBtn from "./../../assets/images/arrow-left.png";
import leftBtnBlr from "./../../assets/images/arrow-left-blur.png";
import rightBtn from "./../../assets/images/arrow_right.png";
import rightBtnBlr from "./../../assets/images/arrow-right-blur.png";
import ProfileCard from "./ProfileCard";
export default class SpeakerSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sliders: [],
      sliderBtn: false,
      activeSlide2: 0,
      activeSlide: 0,
    };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }
  next() {
    this.slider.slickNext();
    this.setState({ sliderBtn: true })


  }
  previous() {
    this.slider.slickPrev();
  }
  render() {
    const settings = {
      className: "center",
      dots: true,
      infinite: false,
      centerPadding: "60px",
      slidesToShow: 3,
      speed: 500,
      rows: 2,
      slidesToScroll: 3,
      slidesPerRow: 1,
      beforeChange: (current, next) => this.setState({ activeSlide: next }),
      afterChange: current => this.setState({ activeSlide2: current * 2 + 6 }),
      responsive: [
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            rows: 2,
            afterChange: current => this.setState({ activeSlide2: current + 1 }),
          },
        },

        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
          },
        },
      ],
    };


    return (
      <div className="news-slider">
        {this.props?.title &&
          <h5 className="techno-title py-3">{this.props?.title
          }</h5>
        }

        <Slider ref={c => (this.slider = c)} {...settings}>
          {
            this.props?.speakerSlider?.map((speakerInfo, index) => <ProfileCard speakerInfo={speakerInfo} key={index + 1} />)
          }

        </Slider>
        <div className="d-flex mx-2 mt-5 mt-md-3 justify-content-between justify-content-md-around">
        
              <img
                src={this.state.activeSlide === 0 ? leftBtn : leftBtnBlr}
                alt=""
                className="img-fluid pinter-cursor "
                onClick={this.previous}
              />

              <img
                src={this.state.activeSlide2 === this.props?.speakerSlider?.length ? rightBtnBlr :
                  this.state.activeSlide2 === this.state.speakerSlider?.length + 1 ? rightBtnBlr : rightBtn}
                alt=""
                className="img-fluid pinter-cursor "
                onClick={this.next}
              />
            </div>
           
        
      </div>
    );
  }
}

